import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  DuplicateOptions,
  EntitySectionApi,
  FilterEntitySectionOptions,
  FindEntitySectionForInheritQuery,
  SyncEntitySection,
} from 'api';

export const filterEntitySection = createAsyncThunk(
  'entitySection/filterEntitySection',
  async (option: FilterEntitySectionOptions, { rejectWithValue }) => {
    try {
      const response = await EntitySectionApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterEntitySectionForSelect = createAsyncThunk(
  'entitySection/filterEntitySectionForSelect',
  async (option: FilterEntitySectionOptions, { rejectWithValue }) => {
    try {
      const response = await EntitySectionApi.filterForSelect(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findDiaryListFromEntitySection = createAsyncThunk(
  'section/findDiaryListFromEntitySection',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntitySectionApi.findDiaryListFromEntitySection(
        id
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findListEntitySectionFuture = createAsyncThunk(
  'section/findListEntitySectionFuture',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response =
        await EntitySectionApi.findEntitySectionByProductObjectID(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findInheritEntitySection = createAsyncThunk(
  'entitySection/findInheritEntitySection',
  async (params: FindEntitySectionForInheritQuery, { rejectWithValue }) => {
    try {
      const response = await EntitySectionApi.findInheritEntitySection(params);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntitySection = createAsyncThunk(
  'entitySection/createEntitySection',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntitySectionApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntitySection = createAsyncThunk(
  'entitySection/findOneEntitySection',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await EntitySectionApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createGenerateSectionList = createAsyncThunk(
  'entitySection/createGenerateSectionList',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntitySectionApi.createGenerateSectionList(
        id,
        body
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkExistEntitySections = createAsyncThunk(
  'entitySection/checkExistEntitySections',
  async (
    params: { entityIDs: string[]; entitySectionIDs: string[] },
    { rejectWithValue }
  ) => {
    const { entityIDs, entitySectionIDs } = params;

    try {
      const response = await EntitySectionApi.checkExistEntitySections(
        entityIDs,
        entitySectionIDs
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const syncEntitySectionsInChain = createAsyncThunk(
  'entitySection/syncEntitySectionsInChain',
  async (body: SyncEntitySection, { rejectWithValue }) => {
    try {
      const response = await EntitySectionApi.syncEntitySectionsInChain(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const duplicateEntitySection = createAsyncThunk(
  'entitySection/duplicateEntitySection',
  async (body: DuplicateOptions, { rejectWithValue }) => {
    try {
      const response = await EntitySectionApi.duplicate(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createReuseDiary = createAsyncThunk(
  'entitySection/duplicateEntitySection',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntitySectionApi.createReuseDiary(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntitySection = createAsyncThunk(
  'entitySection/updateEntitySection',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntitySectionApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntitySection = createAsyncThunk(
  'entitySection/removeEntitySection',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntitySectionApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  query: any;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  query: {},
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const entitySectionSlice = createSlice({
  name: 'entitySection',
  initialState,
  reducers: {
    reloadEntitySection(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEntitySection(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEntitySection(state, action) {
      state.savedList = action.payload;
    },
  },
});

const { actions, reducer: entitySectionReducer } = entitySectionSlice;

export const {
  reloadEntitySection,
  updateSavedPaginationEntitySection,
  updateSavedListEntitySection,
} = actions;

export default entitySectionReducer;
